import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import '@/assets/css/slider.css';

Vue.component('VueSlider', VueSlider);
